import React, { useCallback } from 'react';

import { ReactComponent as CrossButton } from './../crossButton.svg';
import classNames from 'classnames';

const SelectedList = ({ name, field, items, values, setValues, isHorizontal }) => {
    const handleRemove = useCallback(
        item => {
            setValues(prevValues => ({
                ...prevValues,
                [name]: values[name].filter(valuesItem => item.uid !== valuesItem.uid),
            }));
        },
        [values, setValues, name]
    );

    const selectedList = items.map(item => (
        <li key={item.uid}>
            <button type="button" className={`${field}__item`} onClick={() => handleRemove(item)}>
                <div>{item.name || item.email}</div>
                <CrossButton />
            </button>
        </li>
    ));

    const listClass = classNames({
        selectedList: true,
        horizontal: isHorizontal,
    });

    return (
        <div className={`${field}-wrap`}>
            <ul className={listClass}>{selectedList}</ul>
        </div>
    );
};

export default SelectedList;
